import { DateInput, useTranslate } from 'react-admin';
import type { DateInputProps } from 'ra-ui-materialui';
import { Box, InputLabel } from '@mui/material';

export const GrayDateInputWithUpperLabel = (props: DateInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <DateInput
        {...props}
        className={props.className ? `${props.className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        size={props.size}
        InputProps={{
          ...props.InputProps,
          notched: false,
        }}
        sx={[
          {
            mt: 0,
            mb: 0,
            '& .MuiOutlinedInput-root': {
              boxSizing: 'border-box',
              height: props.size === 'small' ? 40 : 56,
              alignItems: 'center',
            },
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
        InputLabelProps={{
          ...props.InputLabelProps,
          shrink: true,
        }}
      />
    </Box>
  );

};
